import moment from 'moment';

export type Error = {
  name?: null | string,
  startDate?: null | string,
  endDate?: null | string,
  startTime?: null | string,
  endTime?: null | string,
  duration?: null | string,
  valid?: boolean
};

type Validation = {
  name: null | string,
  startDate: null | string,
  endDate: null | string,
  startTime: null | string,
  endTime: null | string,
  duration: null | string
};

export const defaultErrors = {
  name: null,
  startDate: null,
  endDate: null,
  startTime: null,
  endTime: null,
  duration: null,
  valid: true
};

const validate = (values: Validation, submit: boolean = false) => {
  const valuesValidation: Error = { ...defaultErrors };

  // Validation if form isn't submitted yet
  valuesValidation.endDate = values.startDate && values.endDate && moment(values.startDate).isAfter(values.endDate)
    ? 'End Date cannot be before Start Date'
    : null;

  const startTimeAsMoment = moment(values.startTime, 'HH:mm a');
  const endTimeAsMoment = moment(values.endTime, 'HH:mm a');
  valuesValidation.endTime = values.startTime && values.endTime && moment(startTimeAsMoment).isAfter(endTimeAsMoment)
    ? 'End Time cannot be before Start Time'
    : null;

  // Validation if form is attempting to be submitted
  if (submit) {
    valuesValidation.startTime = values.startTime === null
      ? 'Start Time is Required'
      : null;

    valuesValidation.endTime = values.endTime === null
      ? 'End Time is Required'
      : null;

    valuesValidation.duration = !values.duration
      ? 'Duration is Required'
      : null;
  }

  // Check if we are valid at this point
  for (const [key, value] of Object.entries(valuesValidation)) {
    if (key !== 'valid' && !!value) {
      valuesValidation.valid = false;
      break;
    }
  }
  return valuesValidation;
};

export default validate;
